import { PropsWithChildren, useEffect } from 'react'
import Posthog, { PostHogConfig } from 'posthog-js'
import { PostHogProvider } from 'posthog-js/react'

const posthogOptions: Partial<PostHogConfig> = {
  api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
  debug: import.meta.env.DEV,
  // __preview_experimental_cookieless_mode: true,
  secure_cookie: !import.meta.env.DEV,
  persistence_name: 'foxino_persist',
  before_send: (event) => {
    // Remove classroom ID from path, e.g. /classrooms/:id/learning-plan -> /classrooms/learning-plan
    const classroomRegex = /\/classrooms\/[a-f0-9-]+/gi
    // Remove collection ID from path, e.g. /collection/:id -> /collection
    const collectionRegex = /\/collection\/[a-f0-9-]+/gi
    // Remove quiz-editor language and ID, e.g. /quiz-editor/ENGLISH/:id -> /quiz-editor/ENGLISH
    const quizEditorRegex = /\/quiz-editor\/[^/]+\/[a-f0-9-]+/gi

    if (event && event.properties) {
      if (typeof event.properties.$current_url === 'string') {
        event.properties.$current_url = event.properties.$current_url
          .replace(classroomRegex, '/classrooms')
          .replace(collectionRegex, '/collection')
          .replace(quizEditorRegex, (match) => {
            // Keep only /quiz-editor/ENGLISH (remove the id)
            const parts = match.split('/')
            return `/${parts[1]}/${parts[2]}`
          })
      }
      if (typeof event.properties.$pathname === 'string') {
        event.properties.$pathname = event.properties.$pathname
          .replace(classroomRegex, '/classrooms')
          .replace(collectionRegex, '/collection')
          .replace(quizEditorRegex, (match) => {
            const parts = match.split('/')
            return `/${parts[1]}/${parts[2]}`
          })
      }
    }
    return event
  }
}

export const PostHogProviderWrapper = ({ children }: PropsWithChildren) => {
  // To test on localhost remove !import.meta.env.DEV
  const isEnabled = import.meta.env.VITE_PUBLIC_POSTHOG_ENABLED === 'true' && !import.meta.env.DEV

  useEffect(() => {
    if (isEnabled) {
      Posthog.init(import.meta.env.VITE_PUBLIC_POSTHOG_KEY, posthogOptions)
    }

    console.info('PostHog initialized:', isEnabled)
  }, [])

  if (!isEnabled) return <>{children}</>

  return (
    <PostHogProvider apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY} options={posthogOptions}>
      {children}
    </PostHogProvider>
  )
}
